(function() {
  const mediaCarousels = document.querySelectorAll('[id^="media-carousel-"]');

  if (mediaCarousels.length > 0) {
    // Initialize each media carousel
    mediaCarousels.forEach((carousel, index) => {
      const totalSlides = carousel.querySelectorAll('.glide__slide').length;
      const options = {
        type: 'carousel',
        perView: 6.5,
        perTouch: 1,
        gap: 20,
        animationDuration: 150,
        breakpoints: {
          1024: { perView: 4.5, swipeThreshold: true },
          768: { perView: 2.5, swipeThreshold: true },
        },
      };

      const glide = new Glide(carousel, options);

      glide.on('mount.before', () => {
        const currentPerView = window.innerWidth >= 1024 ? 6.5 : window.innerWidth >= 768 ? 4.5 : 2.5;

        if (totalSlides <= currentPerView) {
          // Disable dragging by preventing touchstart and mousedown events
          const track = carousel.querySelector('.glide__track');
          if (track) {
            track.style.cursor = 'default';
            track.addEventListener('touchstart', (e) => e.stopPropagation(), true);
            track.addEventListener('mousedown', (e) => e.stopPropagation(), true);
          }
        }
      });

      glide.mount();
    });
  }
  })();
